import type { ReactNode } from 'react';
import { useI18n } from '../../contexts/I18nContext';

// Shared card + small formatting helpers for the task reports sections.

export function ReportCard({
  title,
  actions,
  children,
}: {
  title: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    // min-w-0: inside the page's grids a wide table/chart would otherwise set
    // the column width and push the whole page sideways on a phone.
    <section className="min-w-0 rounded-lg border border-gray-200 bg-white p-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="text-sm font-semibold text-gray-900">{title}</h2>
        {actions}
      </div>
      <div className="mt-3">{children}</div>
    </section>
  );
}

/** Loading / error placeholder shared by every report section. */
export function SectionState({ isLoading, isError }: { isLoading: boolean; isError: boolean }) {
  const { t } = useI18n();
  if (isLoading) return <p className="text-sm text-gray-400">{t('reports.loading')}</p>;
  if (isError) return <p className="text-sm text-red-600">{t('reports.error')}</p>;
  return null;
}

export function formatHours(n: number): string {
  const rounded = Math.round(n * 10) / 10;
  return `${Number.isInteger(rounded) ? rounded : rounded.toFixed(1)}h`;
}

export function formatPercent(ratio: number): string {
  return `${Math.round(ratio * 100)}%`;
}

/** Render an ISO timestamp (or date) as YYYY-MM-DD, or a dash when null. */
export function formatDay(iso: string | null): string {
  return iso ? iso.slice(0, 10) : '—';
}
